module.exports = __webpack_public_path__ + "img/logo-linux.6b5e6f8d.png";